<script>
    /**
     * @author Evgeny Shevtsov, info@sitespring.ru
     * @homepage http://sitespring.ru
     * @licence Proprietary
     */
    import BaseStore from "../../../models/BaseStore";
    import ProductProperty from "../../../models/ProductProperty";
    import filter from "lodash/filter";

    class PropertyStore extends BaseStore {
        static entityName = 'product-property';

        options() {
            return {
                ...super.options(),
                model: ProductProperty,
                fetchParams: {
                    fields: 'id,name',
                    sort: 'name',
                    limit: 0
                }
            }
        }
    }


    export default {
        name: "Main",

        data() {
            return {
                selection: null,
                store: new PropertyStore(),
                filterText: ""
            }
        },

        computed: {
            models: vm => filter(vm.store.models, m => m.name.indexOf(vm.filterText) > -1)
        },


        mounted() {
            this.store.fetch();
        },


        methods: {
            onRowSelect(currentRow, oldCurrentRow) {
                this.$router.push({
                    name: 'products-property-edit',
                    params: {
                        model: currentRow
                    }
                });

            },

            onAddClick() {
                this.$router.push({
                    name: 'products-property-edit'
                });
            }
        }
    }
</script>


<template>
    <div v-loading="store.loading">
        <div style="max-width: 600px">
            <P>Здесь задаются предопределенные названия характеристик Продукта.</P>
            <el-container class="toolbar">
                <el-input prefix-icon="el-icon-search"
                          placeholder="Фильтр по названию..."
                          v-model="filterText"
                          clearable></el-input>
                <el-button type="primary"
                           @click="onAddClick">Создать
                </el-button>
            </el-container>

            <el-table :show-header="false"
                      highlight-current-row
                      @current-change="onRowSelect"
                      :data="models">
                <el-table-column prop="$.name"></el-table-column>
                <el-table-column width="35">
                    <el-icon class="el-icon-arrow-right"></el-icon>
                </el-table-column>
            </el-table>
        </div>

    </div>
</template>


<style lang="scss">
    .toolbar {
        > * + * {
            margin-left: 10px;
        }
    }

    td {
        cursor: pointer;
    }
</style>